import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FerramentasDeDetalhe, RadioGroup, CheckBox, ILstLiga } from "../../shered/components";
import { VForm, VTextField, VScope, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { IDetalheMensagemPorUsuario, IDetalheMensagemPorUsuarioCreate, IDetalheUsuario, UsuarioService } from "../../shered/services/api/usuario/UsuarioService";
import CookieService from "../../shered/services/autenticacao/CookieService";
import {
    Box, Checkbox, FormControl, FormControlLabel, Paper, Switch, Typography,  useTheme
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { Loading } from "../../shered/components/loading/Loading";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { useAuthContext } from "../../shered/contexts";
import { LigaService } from "../../shered/services/api/liga/LigaService";

export const DetalheDeConfigMensagem: React.FC = () => {
    const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");

    const [isLoading, setIsLoading] = useState(false);
    const [nome, setNome] = useState("");
    const [ativo, setAtivo] = useState(true);
    const [administrador, setAdministrador] = useState(true);
    const theme = useTheme();
    const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const navigate = useNavigate();
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    const { logout } = useAuthContext();
    const [redirecionar, setRedirecionar] = useState("0");
    const [adm, setAdm] = useState(false);
    const [cod_Usuario, setCod_Usuario] = useState(0);
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [listaPermissoes, setListaPermissoes] = useState<IDetalheMensagemPorUsuario[]>([]);


    const [email0, setEmail0] = useState(false);
    const [leilao0, setLeilao0] = useState(false);
    const [telegram0, setTelegram0] = useState(false);
    const [proposta0, setProposta0] = useState(false);
    const [freeAgency0, setFreeAgency0] = useState(false);
    const [labelLeilao0, setLabelLeilao0] = useState("Não");
    const [labelProposta0, setLabelProposta0] = useState("Não");
    const [labelFreeAgency0, setLabelFreeAgency0] = useState("Não");
    const [draft0, setDraft0] = useState(false);
    const [labelDraft0, setLabelDraft0] = useState("Não");
    const [partida0, setPartida0] = useState(false);
    const [labelPartida0, setLabelPartida0] = useState("Não");

    const [leilaoGeral0, setLeilaoGeral0] = useState(false);
    const [propostaGeral0, setPropostaGeral0] = useState(false);
    const [freeAgencyGeral0, setFreeAgencyGeral0] = useState(false);
    const [labelLeilaoGeral0, setLabelLeilaoGeral0] = useState("Não");
    const [labelPropostaGeral0, setLabelPropostaGeral0] = useState("Não");
    const [labelFreeAgencyGeral0, setLabelFreeAgencyGeral0] = useState("Não");
    const [draftGeral0, setDraftGeral0] = useState(false);
    const [labelDraftGeral0, setLabelDraftGeral0] = useState("Não");
    const [partidaGeral0, setPartidaGeral0] = useState(false);
    const [labelPartidaGeral0, setLabelPartidaGeral0] = useState("Não");

    const [email1, setEmail1] = useState(false);
    const [leilao1, setLeilao1] = useState(false);
    const [telegram1, setTelegram1] = useState(false);
    const [proposta1, setProposta1] = useState(false);
    const [freeAgency1, setFreeAgency1] = useState(false);
    const [labelLeilao1, setLabelLeilao1] = useState("Não");
    const [labelProposta1, setLabelProposta1] = useState("Não");
    const [labelFreeAgency1, setLabelFreeAgency1] = useState("Não");
    const [draft1, setDraft1] = useState(false);
    const [labelDraft1, setLabelDraft1] = useState("Não");
    const [partida1, setPartida1] = useState(false);
    const [labelPartida1, setLabelPartida1] = useState("Não");

    const [leilaoGeral1, setLeilaoGeral1] = useState(false);
    const [propostaGeral1, setPropostaGeral1] = useState(false);
    const [freeAgencyGeral1, setFreeAgencyGeral1] = useState(false);
    const [labelLeilaoGeral1, setLabelLeilaoGeral1] = useState("Não");
    const [labelPropostaGeral1, setLabelPropostaGeral1] = useState("Não");
    const [labelFreeAgencyGeral1, setLabelFreeAgencyGeral1] = useState("Não");
    const [draftGeral1, setDraftGeral1] = useState(false);
    const [labelDraftGeral1, setLabelDraftGeral1] = useState("Não");
    const [partidaGeral1, setPartidaGeral1] = useState(false);
    const [labelPartidaGeral1, setLabelPartidaGeral1] = useState("Não");

    
    const [email2, setEmail2] = useState(false);
    const [leilao2, setLeilao2] = useState(false);
    const [telegram2, setTelegram2] = useState(false);
    const [proposta2, setProposta2] = useState(false);
    const [freeAgency2, setFreeAgency2] = useState(false);
    const [labelLeilao2, setLabelLeilao2] = useState("Não");
    const [labelProposta2, setLabelProposta2] = useState("Não");
    const [labelFreeAgency2, setLabelFreeAgency2] = useState("Não");
    const [draft2, setDraft2] = useState(false);
    const [labelDraft2, setLabelDraft2] = useState("Não");
    const [partida2, setPartida2] = useState(false);
    const [labelPartida2, setLabelPartida2] = useState("Não");

    const [leilaoGeral2, setLeilaoGeral2] = useState(false);
    const [propostaGeral2, setPropostaGeral2] = useState(false);
    const [freeAgencyGeral2, setFreeAgencyGeral2] = useState(false);
    const [labelLeilaoGeral2, setLabelLeilaoGeral2] = useState("Não");
    const [labelPropostaGeral2, setLabelPropostaGeral2] = useState("Não");
    const [labelFreeAgencyGeral2, setLabelFreeAgencyGeral2] = useState("Não");
    const [draftGeral2, setDraftGeral2] = useState(false);
    const [labelDraftGeral2, setLabelDraftGeral2] = useState("Não");
    const [partidaGeral2, setPartidaGeral2] = useState(false);
    const [labelPartidaGeral2, setLabelPartidaGeral2] = useState("Não");


    const [email3, setEmail3] = useState(false);
    const [leilao3, setLeilao3] = useState(false);
    const [telegram3, setTelegram3] = useState(false);
    const [proposta3, setProposta3] = useState(false);
    const [freeAgency3, setFreeAgency3] = useState(false);
    const [labelLeilao3, setLabelLeilao3] = useState("Não");
    const [labelProposta3, setLabelProposta3] = useState("Não");
    const [labelFreeAgency3, setLabelFreeAgency3] = useState("Não");
    const [draft3, setDraft3] = useState(false);
    const [labelDraft3, setLabelDraft3] = useState("Não");
    const [partida3, setPartida3] = useState(false);
    const [labelPartida3, setLabelPartida3] = useState("Não");

    const [leilaoGeral3, setLeilaoGeral3] = useState(false);
    const [propostaGeral3, setPropostaGeral3] = useState(false);
    const [freeAgencyGeral3, setFreeAgencyGeral3] = useState(false);
    const [labelLeilaoGeral3, setLabelLeilaoGeral3] = useState("Não");
    const [labelPropostaGeral3, setLabelPropostaGeral3] = useState("Não");
    const [labelFreeAgencyGeral3, setLabelFreeAgencyGeral3] = useState("Não");
    const [draftGeral3, setDraftGeral3] = useState(false);
    const [labelDraftGeral3, setLabelDraftGeral3] = useState("Não");
    const [partidaGeral3, setPartidaGeral3] = useState(false);
    const [labelPartidaGeral3, setLabelPartidaGeral3] = useState("Não");


    const [email4, setEmail4] = useState(false);
    const [leilao4, setLeilao4] = useState(false);
    const [telegram4, setTelegram4] = useState(false);
    const [proposta4, setProposta4] = useState(false);
    const [freeAgency4, setFreeAgency4] = useState(false);
    const [labelLeilao4, setLabelLeilao4] = useState("Não");
    const [labelProposta4, setLabelProposta4] = useState("Não");
    const [labelFreeAgency4, setLabelFreeAgency4] = useState("Não");
    const [draft4, setDraft4] = useState(false);
    const [labelDraft4, setLabelDraft4] = useState("Não");
    const [partida4, setPartida4] = useState(false);
    const [labelPartida4, setLabelPartida4] = useState("Não");

    const [leilaoGeral4, setLeilaoGeral4] = useState(false);
    const [propostaGeral4, setPropostaGeral4] = useState(false);
    const [freeAgencyGeral4, setFreeAgencyGeral4] = useState(false);
    const [labelLeilaoGeral4, setLabelLeilaoGeral4] = useState("Não");
    const [labelPropostaGeral4, setLabelPropostaGeral4] = useState("Não");
    const [labelFreeAgencyGeral4, setLabelFreeAgencyGeral4] = useState("Não");
    const [draftGeral4, setDraftGeral4] = useState(false);
    const [labelDraftGeral4, setLabelDraftGeral4] = useState("Não");
    const [partidaGeral4, setPartidaGeral4] = useState(false);
    const [labelPartidaGeral4, setLabelPartidaGeral4] = useState("Não");


    const [email5, setEmail5] = useState(false);
    const [leilao5, setLeilao5] = useState(false);
    const [telegram5, setTelegram5] = useState(false);
    const [proposta5, setProposta5] = useState(false);
    const [freeAgency5, setFreeAgency5] = useState(false);
    const [labelLeilao5, setLabelLeilao5] = useState("Não");
    const [labelProposta5, setLabelProposta5] = useState("Não");
    const [labelFreeAgency5, setLabelFreeAgency5] = useState("Não");
    const [draft5, setDraft5] = useState(false);
    const [labelDraft5, setLabelDraft5] = useState("Não");
    const [partida5, setPartida5] = useState(false);
    const [labelPartida5, setLabelPartida5] = useState("Não");


    const [leilaoGeral5, setLeilaoGeral5] = useState(false);
    const [propostaGeral5, setPropostaGeral5] = useState(false);
    const [freeAgencyGeral5, setFreeAgencyGeral5] = useState(false);
    const [labelLeilaoGeral5, setLabelLeilaoGeral5] = useState("Não");
    const [labelPropostaGeral5, setLabelPropostaGeral5] = useState("Não");
    const [labelFreeAgencyGeral5, setLabelFreeAgencyGeral5] = useState("Não");
    const [draftGeral5, setDraftGeral5] = useState(false);
    const [labelDraftGeral5, setLabelDraftGeral5] = useState("Não");
    const [partidaGeral5, setPartidaGeral5] = useState(false);
    const [labelPartidaGeral5, setLabelPartidaGeral5] = useState("Não");

    const [email6, setEmail6] = useState(false);
    const [leilao6, setLeilao6] = useState(false);
    const [telegram6, setTelegram6] = useState(false);
    const [proposta6, setProposta6] = useState(false);
    const [freeAgency6, setFreeAgency6] = useState(false);
    const [labelLeilao6, setLabelLeilao6] = useState("Não");
    const [labelProposta6, setLabelProposta6] = useState("Não");
    const [labelFreeAgency6, setLabelFreeAgency6] = useState("Não");
    const [draft6, setDraft6] = useState(false);
    const [labelDraft6, setLabelDraft6] = useState("Não");
    const [partida6, setPartida6] = useState(false);
    const [labelPartida6, setLabelPartida6] = useState("Não");

    const [leilaoGeral6, setLeilaoGeral6] = useState(false);
    const [propostaGeral6, setPropostaGeral6] = useState(false);
    const [freeAgencyGeral6, setFreeAgencyGeral6] = useState(false);
    const [labelLeilaoGeral6, setLabelLeilaoGeral6] = useState("Não");
    const [labelPropostaGeral6, setLabelPropostaGeral6] = useState("Não");
    const [labelFreeAgencyGeral6, setLabelFreeAgencyGeral6] = useState("Não");
    const [draftGeral6, setDraftGeral6] = useState(false);
    const [labelDraftGeral6, setLabelDraftGeral6] = useState("Não");
    const [partidaGeral6, setPartidaGeral6] = useState(false);
    const [labelPartidaGeral6, setLabelPartidaGeral6] = useState("Não");

    const [email7, setEmail7] = useState(false);
    const [leilao7, setLeilao7] = useState(false);
    const [telegram7, setTelegram7] = useState(false);
    const [proposta7, setProposta7] = useState(false);
    const [freeAgency7, setFreeAgency7] = useState(false);
    const [labelLeilao7, setLabelLeilao7] = useState("Não");
    const [labelProposta7, setLabelProposta7] = useState("Não");
    const [labelFreeAgency7, setLabelFreeAgency7] = useState("Não");
    const [draft7, setDraft7] = useState(false);
    const [labelDraft7, setLabelDraft7] = useState("Não");
    const [partida7, setPartida7] = useState(false);
    const [labelPartida7, setLabelPartida7] = useState("Não");

    const [leilaoGeral7, setLeilaoGeral7] = useState(false);
    const [propostaGeral7, setPropostaGeral7] = useState(false);
    const [freeAgencyGeral7, setFreeAgencyGeral7] = useState(false);
    const [labelLeilaoGeral7, setLabelLeilaoGeral7] = useState("Não");
    const [labelPropostaGeral7, setLabelPropostaGeral7] = useState("Não");
    const [labelFreeAgencyGeral7, setLabelFreeAgencyGeral7] = useState("Não");
    const [draftGeral7, setDraftGeral7] = useState(false);
    const [labelDraftGeral7, setLabelDraftGeral7] = useState("Não");
    const [partidaGeral7, setPartidaGeral7] = useState(false);
    const [labelPartidaGeral7, setLabelPartidaGeral7] = useState("Não");


    const [email8, setEmail8] = useState(false);
    const [leilao8, setLeilao8] = useState(false);
    const [telegram8, setTelegram8] = useState(false);
    const [proposta8, setProposta8] = useState(false);
    const [freeAgency8, setFreeAgency8] = useState(false);
    const [labelLeilao8, setLabelLeilao8] = useState("Não");
    const [labelProposta8, setLabelProposta8] = useState("Não");
    const [labelFreeAgency8, setLabelFreeAgency8] = useState("Não");
    const [draft8, setDraft8] = useState(false);
    const [labelDraft8, setLabelDraft8] = useState("Não");
    const [partida8, setPartida8] = useState(false);
    const [labelPartida8, setLabelPartida8] = useState("Não");

    const [leilaoGeral8, setLeilaoGeral8] = useState(false);
    const [propostaGeral8, setPropostaGeral8] = useState(false);
    const [freeAgencyGeral8, setFreeAgencyGeral8] = useState(false);
    const [labelLeilaoGeral8, setLabelLeilaoGeral8] = useState("Não");
    const [labelPropostaGeral8, setLabelPropostaGeral8] = useState("Não");
    const [labelFreeAgencyGeral8, setLabelFreeAgencyGeral8] = useState("Não");
    const [draftGeral8, setDraftGeral8] = useState(false);
    const [labelDraftGeral8, setLabelDraftGeral8] = useState("Não");
    const [partidaGeral8, setPartidaGeral8] = useState(false);
    const [labelPartidaGeral8, setLabelPartidaGeral8] = useState("Não");


    const [email9, setEmail9] = useState(false);
    const [leilao9, setLeilao9] = useState(false);
    const [telegram9, setTelegram9] = useState(false);
    const [proposta9, setProposta9] = useState(false);
    const [freeAgency9, setFreeAgency9] = useState(false);
    const [labelLeilao9, setLabelLeilao9] = useState("Não");
    const [labelProposta9, setLabelProposta9] = useState("Não");
    const [labelFreeAgency9, setLabelFreeAgency9] = useState("Não");
    const [draft9, setDraft9] = useState(false);
    const [labelDraft9, setLabelDraft9] = useState("Não");
    const [partida9, setPartida9] = useState(false);
    const [labelPartida9, setLabelPartida9] = useState("Não");

    const [leilaoGeral9, setLeilaoGeral9] = useState(false);
    const [propostaGeral9, setPropostaGeral9] = useState(false);
    const [freeAgencyGeral9, setFreeAgencyGeral9] = useState(false);
    const [labelLeilaoGeral9, setLabelLeilaoGeral9] = useState("Não");
    const [labelPropostaGeral9, setLabelPropostaGeral9] = useState("Não");
    const [labelFreeAgencyGeral9, setLabelFreeAgencyGeral9] = useState("Não");
    const [draftGeral9, setDraftGeral9] = useState(false);
    const [labelDraftGeral9, setLabelDraftGeral9] = useState("Não");
    const [partidaGeral9, setPartidaGeral9] = useState(false);
    const [labelPartidaGeral9, setLabelPartidaGeral9] = useState("Não");


    const [email10, setEmail10] = useState(false);
    const [leilao10, setLeilao10] = useState(false);
    const [telegram10, setTelegram10] = useState(false);
    const [proposta10, setProposta10] = useState(false);
    const [freeAgency10, setFreeAgency10] = useState(false);
    const [labelLeilao10, setLabelLeilao10] = useState("Não");
    const [labelProposta10, setLabelProposta10] = useState("Não");
    const [labelFreeAgency10, setLabelFreeAgency10] = useState("Não");
    const [draft10, setDraft10] = useState(false);
    const [labelDraft10, setLabelDraft10] = useState("Não");
    const [partida10, setPartida10] = useState(false);
    const [labelPartida10, setLabelPartida10] = useState("Não");

    const [leilaoGeral10, setLeilaoGeral10] = useState(false);
    const [propostaGeral10, setPropostaGeral10] = useState(false);
    const [freeAgencyGeral10, setFreeAgencyGeral10] = useState(false);
    const [labelLeilaoGeral10, setLabelLeilaoGeral10] = useState("Não");
    const [labelPropostaGeral10, setLabelPropostaGeral10] = useState("Não");
    const [labelFreeAgencyGeral10, setLabelFreeAgencyGeral10] = useState("Não");
    const [draftGeral10, setDraftGeral10] = useState(false);
    const [labelDraftGeral10, setLabelDraftGeral10] = useState("Não");
    const [partidaGeral10, setPartidaGeral10] = useState(false);
    const [labelPartidaGeral10, setLabelPartidaGeral10] = useState("Não");


    const [email11, setEmail11] = useState(false);
    const [leilao11, setLeilao11] = useState(false);
    const [telegram11, setTelegram11] = useState(false);
    const [proposta11, setProposta11] = useState(false);
    const [freeAgency11, setFreeAgency11] = useState(false);
    const [labelLeilao11, setLabelLeilao11] = useState("Não");
    const [labelProposta11, setLabelProposta11] = useState("Não");
    const [labelFreeAgency11, setLabelFreeAgency11] = useState("Não");
    const [draft11, setDraft11] = useState(false);
    const [labelDraft11, setLabelDraft11] = useState("Não");
    const [partida11, setPartida11] = useState(false);
    const [labelPartida11, setLabelPartida11] = useState("Não");

    const [leilaoGeral11, setLeilaoGeral11] = useState(false);
    const [propostaGeral11, setPropostaGeral11] = useState(false);
    const [freeAgencyGeral11, setFreeAgencyGeral11] = useState(false);
    const [labelLeilaoGeral11, setLabelLeilaoGeral11] = useState("Não");
    const [labelPropostaGeral11, setLabelPropostaGeral11] = useState("Não");
    const [labelFreeAgencyGeral11, setLabelFreeAgencyGeral11] = useState("Não");
    const [draftGeral11, setDraftGeral11] = useState(false);
    const [labelDraftGeral11, setLabelDraftGeral11] = useState("Não");
    const [partidaGeral11, setPartidaGeral11] = useState(false);
    const [labelPartidaGeral11, setLabelPartidaGeral11] = useState("Não");

    
    const [email12, setEmail12] = useState(false);
    const [leilao12, setLeilao12] = useState(false);
    const [telegram12, setTelegram12] = useState(false);
    const [proposta12, setProposta12] = useState(false);
    const [freeAgency12, setFreeAgency12] = useState(false);
    const [labelLeilao12, setLabelLeilao12] = useState("Não");
    const [labelProposta12, setLabelProposta12] = useState("Não");
    const [labelFreeAgency12, setLabelFreeAgency12] = useState("Não");
    const [draft12, setDraft12] = useState(false);
    const [labelDraft12, setLabelDraft12] = useState("Não");
    const [partida12, setPartida12] = useState(false);
    const [labelPartida12, setLabelPartida12] = useState("Não");

    const [leilaoGeral12, setLeilaoGeral12] = useState(false);
    const [propostaGeral12, setPropostaGeral12] = useState(false);
    const [freeAgencyGeral12, setFreeAgencyGeral12] = useState(false);
    const [labelLeilaoGeral12, setLabelLeilaoGeral12] = useState("Não");
    const [labelPropostaGeral12, setLabelPropostaGeral12] = useState("Não");
    const [labelFreeAgencyGeral12, setLabelFreeAgencyGeral12] = useState("Não");
    const [draftGeral12, setDraftGeral12] = useState(false);
    const [labelDraftGeral12, setLabelDraftGeral12] = useState("Não");
    const [partidaGeral12, setPartidaGeral12] = useState(false);
    const [labelPartidaGeral12, setLabelPartidaGeral12] = useState("Não");


    const [email13, setEmail13] = useState(false);
    const [leilao13, setLeilao13] = useState(false);
    const [telegram13, setTelegram13] = useState(false);
    const [proposta13, setProposta13] = useState(false);
    const [freeAgency13, setFreeAgency13] = useState(false);
    const [labelLeilao13, setLabelLeilao13] = useState("Não");
    const [labelProposta13, setLabelProposta13] = useState("Não");
    const [labelFreeAgency13, setLabelFreeAgency13] = useState("Não");
    const [draft13, setDraft13] = useState(false);
    const [labelDraft13, setLabelDraft13] = useState("Não");
    const [partida13, setPartida13] = useState(false);
    const [labelPartida13, setLabelPartida13] = useState("Não");

    const [leilaoGeral13, setLeilaoGeral13] = useState(false);
    const [propostaGeral13, setPropostaGeral13] = useState(false);
    const [freeAgencyGeral13, setFreeAgencyGeral13] = useState(false);
    const [labelLeilaoGeral13, setLabelLeilaoGeral13] = useState("Não");
    const [labelPropostaGeral13, setLabelPropostaGeral13] = useState("Não");
    const [labelFreeAgencyGeral13, setLabelFreeAgencyGeral13] = useState("Não");
    const [draftGeral13, setDraftGeral13] = useState(false);
    const [labelDraftGeral13, setLabelDraftGeral13] = useState("Não");
    const [partidaGeral13, setPartidaGeral13] = useState(false);
    const [labelPartidaGeral13, setLabelPartidaGeral13] = useState("Não");


    const [email14, setEmail14] = useState(false);
    const [leilao14, setLeilao14] = useState(false);
    const [telegram14, setTelegram14] = useState(false);
    const [proposta14, setProposta14] = useState(false);
    const [freeAgency14, setFreeAgency14] = useState(false);
    const [labelLeilao14, setLabelLeilao14] = useState("Não");
    const [labelProposta14, setLabelProposta14] = useState("Não");
    const [labelFreeAgency14, setLabelFreeAgency14] = useState("Não");
    const [draft14, setDraft14] = useState(false);
    const [labelDraft14, setLabelDraft14] = useState("Não");
    const [partida14, setPartida14] = useState(false);
    const [labelPartida14, setLabelPartida14] = useState("Não");

    const [leilaoGeral14, setLeilaoGeral14] = useState(false);
    const [propostaGeral14, setPropostaGeral14] = useState(false);
    const [freeAgencyGeral14, setFreeAgencyGeral14] = useState(false);
    const [labelLeilaoGeral14, setLabelLeilaoGeral14] = useState("Não");
    const [labelPropostaGeral14, setLabelPropostaGeral14] = useState("Não");
    const [labelFreeAgencyGeral14, setLabelFreeAgencyGeral14] = useState("Não");
    const [draftGeral14, setDraftGeral14] = useState(false);
    const [labelDraftGeral14, setLabelDraftGeral14] = useState("Não");
    const [partidaGeral14, setPartidaGeral14] = useState(false);
    const [labelPartidaGeral14, setLabelPartidaGeral14] = useState("Não");


    const [email15, setEmail15] = useState(false);
    const [leilao15, setLeilao15] = useState(false);
    const [telegram15, setTelegram15] = useState(false);
    const [proposta15, setProposta15] = useState(false);
    const [freeAgency15, setFreeAgency15] = useState(false);
    const [labelLeilao15, setLabelLeilao15] = useState("Não");
    const [labelProposta15, setLabelProposta15] = useState("Não");
    const [labelFreeAgency15, setLabelFreeAgency15] = useState("Não");
    const [draft15, setDraft15] = useState(false);
    const [labelDraft15, setLabelDraft15] = useState("Não");
    const [partida15, setPartida15] = useState(false);
    const [labelPartida15, setLabelPartida15] = useState("Não");

    const [leilaoGeral15, setLeilaoGeral15] = useState(false);
    const [propostaGeral15, setPropostaGeral15] = useState(false);
    const [freeAgencyGeral15, setFreeAgencyGeral15] = useState(false);
    const [labelLeilaoGeral15, setLabelLeilaoGeral15] = useState("Não");
    const [labelPropostaGeral15, setLabelPropostaGeral15] = useState("Não");
    const [labelFreeAgencyGeral15, setLabelFreeAgencyGeral15] = useState("Não");
    const [draftGeral15, setDraftGeral15] = useState(false);
    const [labelDraftGeral15, setLabelDraftGeral15] = useState("Não");
    const [partidaGeral15, setPartidaGeral15] = useState(false);
    const [labelPartidaGeral15, setLabelPartidaGeral15] = useState("Não");


    const [email16, setEmail16] = useState(false);
    const [leilao16, setLeilao16] = useState(false);
    const [telegram16, setTelegram16] = useState(false);
    const [proposta16, setProposta16] = useState(false);
    const [freeAgency16, setFreeAgency16] = useState(false);
    const [labelLeilao16, setLabelLeilao16] = useState("Não");
    const [labelProposta16, setLabelProposta16] = useState("Não");
    const [labelFreeAgency16, setLabelFreeAgency16] = useState("Não");
    const [draft16, setDraft16] = useState(false);
    const [labelDraft16, setLabelDraft16] = useState("Não");
    const [partida16, setPartida16] = useState(false);
    const [labelPartida16, setLabelPartida16] = useState("Não");

    const [leilaoGeral16, setLeilaoGeral16] = useState(false);
    const [propostaGeral16, setPropostaGeral16] = useState(false);
    const [freeAgencyGeral16, setFreeAgencyGeral16] = useState(false);
    const [labelLeilaoGeral16, setLabelLeilaoGeral16] = useState("Não");
    const [labelPropostaGeral16, setLabelPropostaGeral16] = useState("Não");
    const [labelFreeAgencyGeral16, setLabelFreeAgencyGeral16] = useState("Não");
    const [draftGeral16, setDraftGeral16] = useState(false);
    const [labelDraftGeral16, setLabelDraftGeral16] = useState("Não");
    const [partidaGeral16, setPartidaGeral16] = useState(false);
    const [labelPartidaGeral16, setLabelPartidaGeral16] = useState("Não");

    const [codigoLigaSelecionado, setCodigoLigaSelecionado] = useState(0);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [lstLiga, setLstLiga] = useState<ILstLiga[]>([]);

    useEffect(() => {
        const user = CookieService.get("access_user");
        setAdm(user.administrador);
        setCod_Usuario(user.codUsuario);
        setIsLoading(false);
        setRemoveLoading(true);

        const fetchData = async () => {
            await UsuarioService.getPermissoesMensagemByCodigoUsuario(user.codUsuario)
                //     await LigaService.getAllPorUsuario()
                .then((result) => {
                    const lst = result.dado;                  
                    setListaPermissoes(lst);
                    formRef.current?.setData(lst);
                    // let listaDrop: ILstLiga[] = lst.map(l => ({ codigo: l.codigo, label: l.nome }));
                    // setLstLiga(listaDrop);
                    //setCodigoLigaSelecionado(Number(codigoLiga));


                })
                .catch((errors) => {
                    if (errors.response.data.statusHTTP === 401) {
                        logout();
                        navigate(0);
                        return;
                    }
                });
        }
        fetchData();
    }, []);


    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    }


    const handleSave = async (dados: IDetalheMensagemPorUsuarioCreate[]) => {
        UsuarioService.createConfiguracaoMensagem(listaPermissoes)
            .then((result) => {
                setIsLoading(false);
                setRemoveLoading(true);
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Registro cadastrado com sucesso!",
                    display: "none",
                    titulo: "Atenção"
                });
                // if (isSaveAndClose()) {
                //     setRedirecionar("/adm/usuarios");
                // } else {
                //     setRedirecionar(`/usuario/usuarios/detalhe/${result}`);
                // }
            })
            .catch((errors) => {
                setRemoveLoading(true);
                setShowModalMensagem(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível criar a liga! Favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });
            });

    }

    const handleEscolhaTelegram = (codigoLiga: number, index: number, valor: boolean) => {

        let newValor = !valor;
        eval(`setTelegram${index}(newValor)`);


        formRef.current?.setFieldValue("telegram", eval(`telegram${index}`));
        const list = [...listaPermissoes] as IDetalheMensagemPorUsuario[];
        const newlist = list.map((item) =>
            item.codigo_Liga === codigoLiga ? { ...item, "telegram": newValor } : item
        );
        setListaPermissoes(newlist);
        // let data = formRef.current?.getData();
        // formRef.current?.setData(data);
    }

    const handleEscolhaEmail = (codigoLiga: number, index: number, valor: boolean) => {
        let newValor = !valor;

        eval(`setEmail${index}(newValor)`);
        formRef.current?.setFieldValue("email", eval(`email${index}`));
        const list = [...listaPermissoes] as IDetalheMensagemPorUsuario[];
        const newlist = list.map((item) =>
            item.codigo_Liga === codigoLiga ? { ...item, "email": newValor } : item
        );
        setListaPermissoes(newlist);
        // let data = formRef.current?.getData();
        // formRef.current?.setData(data);
    }

    const handleEscolhaProposta = (codigoLiga: number, index: number, valor: boolean) => {
        let newValor = !valor;
        eval(`setProposta${index}(newValor)`);
        eval(`setLabelProposta${index}(eval(proposta${index}) ? "Não" : "Sim")`);

        const list = [...listaPermissoes] as IDetalheMensagemPorUsuario[];

        const newlist = list.map((item) =>
            item.codigo_Liga === codigoLiga ? { ...item, "proposta": newValor } : item
        );
        setListaPermissoes(newlist);
        formRef.current?.setFieldValue("proposta", eval(`proposta${index}`));    

    }

    const handleEscolhaLeilao = (codigoLiga: number, index: number, valor: boolean) => {
        let newValor = !valor;
        eval(`setLeilao${index}(newValor)`);
        eval(`setLabelLeilao${index}(eval(leilao${index}) ? "Não" : "Sim")`);
        // setLeilao(!leilao);
        // setLabelLeilao(leilao ? "Não" : "Sim");

        const list = [...listaPermissoes] as IDetalheMensagemPorUsuario[];
        const newlist = list.map((item) =>
            item.codigo_Liga === codigoLiga ? { ...item, "leilao": newValor } : item
        );
        setListaPermissoes(newlist);
        formRef.current?.setFieldValue("leilao", eval(`leilao${index}`));
        // let data = formRef.current?.getData();
        // formRef.current?.setData(data);
    }

    const handleEscolhaFreeAgency = (codigoLiga: number, index: number, valor: boolean) => {
        let newValor = !valor;
        eval(`setFreeAgency${index}(newValor)`);
        eval(`setLabelFreeAgency${index}(eval(freeAgency${index}) ? "Não" : "Sim")`);
        formRef.current?.setFieldValue("freeAgency", eval(`freeAgency${index}`));
        const list = [...listaPermissoes] as IDetalheMensagemPorUsuario[];
        const newlist = list.map((item) =>
            item.codigo_Liga === codigoLiga ? { ...item, "freeAgency": newValor } : item
        );
        setListaPermissoes(newlist);

    }

    const handleEscolhaDraft = (codigoLiga: number, index: number, valor: boolean) => {
        let newValor = !valor;
        eval(`setDraft${index}(newValor)`);
        eval(`setLabelDraft${index}(eval(draft${index}) ? "Não" : "Sim")`);

        const list = [...listaPermissoes] as IDetalheMensagemPorUsuario[];
        const newlist = list.map((item) =>
            item.codigo_Liga === codigoLiga ? { ...item, "draft": newValor } : item
        );
        setListaPermissoes(newlist);
        formRef.current?.setFieldValue("draft", eval(`draft${index}`));
    }

    const handleEscolhaPartida = (codigoLiga: number, index: number, valor: boolean) => {
        let newValor = !valor;
        eval(`setPartida${index}(newValor)`);
        eval(`setLabelPartida${index}(eval(partida${index}) ? "Não" : "Sim")`);

        const list = [...listaPermissoes] as IDetalheMensagemPorUsuario[];
        const newlist = list.map((item) =>
            item.codigo_Liga === codigoLiga ? { ...item, "partida": newValor } : item
        );
        setListaPermissoes(newlist);
        formRef.current?.setFieldValue("partida", eval(`partida${index}`));
    }

    const handleEscolhaPropostaGeral = (codigoLiga: number, index: number, valor: boolean) => {
        let newValor = !valor;
        eval(`setPropostaGeral${index}(newValor)`);
        eval(`setLabelPropostaGeral${index}(eval(propostaGeral${index}) ? "Não" : "Sim")`);

        const list = [...listaPermissoes] as IDetalheMensagemPorUsuario[];

        const newlist = list.map((item) =>
            item.codigo_Liga === codigoLiga ? { ...item, "proposta_Geral": newValor } : item
        );
        setListaPermissoes(newlist);
        formRef.current?.setFieldValue("proposta_Geral", eval(`propostaGeral${index}`));
       

    }

    const handleEscolhaLeilaoGeral = (codigoLiga: number, index: number, valor: boolean) => {
        let newValor = !valor;
        eval(`setLeilaoGeral${index}(newValor)`);
        eval(`setLabelLeilaoGeral${index}(eval(leilaoGeral${index}) ? "Não" : "Sim")`);      

        const list = [...listaPermissoes] as IDetalheMensagemPorUsuario[];
        const newlist = list.map((item) =>
            item.codigo_Liga === codigoLiga ? { ...item, "leilao_Geral": newValor } : item
        );
        setListaPermissoes(newlist);
        formRef.current?.setFieldValue("leilao_Geral", eval(`leilaoGeral${index}`));
        // let data = formRef.current?.getData();
        // formRef.current?.setData(data);
    }

    const handleEscolhaFreeAgencyGeral = (codigoLiga: number, index: number, valor: boolean) => {
        let newValor = !valor;
        eval(`setFreeAgencyGeral${index}(newValor)`);
        eval(`setLabelFreeAgencyGeral${index}(eval(freeAgencyGeral${index}) ? "Não" : "Sim")`);
        formRef.current?.setFieldValue("freeAgency_Geral", eval(`freeAgencyGeral${index}`));
        const list = [...listaPermissoes] as IDetalheMensagemPorUsuario[];
        const newlist = list.map((item) =>
            item.codigo_Liga === codigoLiga ? { ...item, "freeAgency_Geral": newValor } : item
        );
        setListaPermissoes(newlist);
        
    }

    const handleEscolhaDraftGeral = (codigoLiga: number, index: number, valor: boolean) => {
        let newValor = !valor;
        eval(`setDraftGeral${index}(newValor)`);
        eval(`setLabelDraftGeral${index}(eval(draftGeral${index}) ? "Não" : "Sim")`);

        const list = [...listaPermissoes] as IDetalheMensagemPorUsuario[];
        const newlist = list.map((item) =>
            item.codigo_Liga === codigoLiga ? { ...item, "draft_Geral": newValor } : item
        );
        setListaPermissoes(newlist);
        formRef.current?.setFieldValue("draft_Geral", eval(`draftGeral${index}`));
    }

    const handleEscolhaPartidaGeral = (codigoLiga: number, index: number, valor: boolean) => {
        let newValor = !valor;
        eval(`setPartidaGeral${index}(newValor)`);
        eval(`setLabelPartidaGeral${index}(eval(partidaGeral${index}) ? "Não" : "Sim")`);

        const list = [...listaPermissoes] as IDetalheMensagemPorUsuario[];
        const newlist = list.map((item) =>
            item.codigo_Liga === codigoLiga ? { ...item, "partida_Geral": newValor } : item
        );
        setListaPermissoes(newlist);
        formRef.current?.setFieldValue("partida_Geral", eval(`partidaGeral${index}`));
    }

    return (
        <LayoutBaseDePagina titulo={"Configuração de Mensagem"}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={false}
                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmVoltar={() => navigate(-1)}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container direction="column" padding={2} spacing={2}>
                        <Grid container direction="column" padding={2} spacing={2}>
                            {!removeLoading && <Loading />}
                        </Grid>
                        <Grid container size={{xs:12, sm:12, md:12}} direction="row" display={"grid"} padding={2} spacing={2}>                          
                            {listaPermissoes.length > 0 && listaPermissoes.map((m, index) =>
                                <Box key={m.codigo_Liga} boxShadow={3} margin={1} padding={1} width={"100%"} sx={{ backgroundColor: "#37383b" }} >
                                    <Grid container size={{xs:12, sm:12, md:12}} margin={1} padding={UtilidadeService.isMobile() ? 2 : 1}  >
                                        <Grid  size={{xs:12, sm:12}} padding={1} >
                                            <Typography variant="h6">Formas de Envio de Mensagem da <span style={{ fontWeight: 600 }}>{m.nome_Liga}</span></Typography>
                                            <hr />
                                        </Grid>
                                        <Grid container size={{xs:12, sm:12, md:12}} margin={1} padding={UtilidadeService.isMobile() ? 2 : 1}  >
                                            <Grid size={{xs:12, sm:4}} padding={1} >
                                                <FormControlLabel
                                                    key="Telegram"
                                                    control={(
                                                        <Checkbox
                                                            name="telegram"
                                                            checked={m.telegram ? true : false}
                                                            onChange={(e) => { handleEscolhaTelegram(m.codigo_Liga, index, m.telegram); }}
                                                            defaultValue={eval(`telegram${index}`)}
                                                            disabled={isLoading}
                                                        />
                                                    )}
                                                    label="Telegram"
                                                />
                                            </Grid>
                                            <Grid size={{xs:12, sm:4}} padding={1} >
                                                <FormControlLabel
                                                    key="Email"
                                                    control={(
                                                        <Checkbox
                                                            name="email"
                                                            checked={m.email ? true : false}
                                                            onChange={(e) => handleEscolhaEmail(m.codigo_Liga, index, m.email)}
                                                            defaultChecked={eval(`m.email${index}`)}
                                                            disabled={isLoading}
                                                        />
                                                    )}
                                                    label="Email"
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid size={{xs:12, sm:3}} padding={1}>
                                            <Grid  size={{xs:12, sm:12, md:12}} display={"flex"} justifyContent={"center"} >
                                                <Typography variant="h6">Propostas / Trocas</Typography>
                                            </Grid>
                                            <Grid container size={{xs:12, sm:12, md:12}} >
                                                <Grid container size={{xs:12, sm:12, md:12}} direction={"column"} display={"contents"} >
                                                    <Grid size={{xs:12, sm:6, md:6}} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                                        <Typography variant="body1">Minha Franquia</Typography>
                                                    </Grid>
                                                    <Grid size={{xs:12, sm:6, md:6}}>
                                                        <FormControlLabel
                                                            sx={{
                                                                display: 'block',
                                                            }}
                                                            control={
                                                                <Switch
                                                                    defaultChecked={true}
                                                                    checked={m.proposta}
                                                                    onChange={() => handleEscolhaProposta(m.codigo_Liga, index, m.proposta)}
                                                                    name={eval(`proposta${index}`)}
                                                                    color="primary"
                                                                />
                                                            }
                                                            label={m.proposta ? "Sim" : "Não"}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{xs:12, sm:12, md:12}} display={"contents"} direction={"column"}>
                                                    <Grid size={{xs:12, sm:6, md:6}} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                                        <Typography variant="body1">Todas da Liga</Typography>
                                                    </Grid>
                                                    <Grid size={{xs:12, sm:6, md:6}} >
                                                        <FormControlLabel
                                                            sx={{
                                                                display: 'block',
                                                            }}
                                                            control={
                                                                <Switch
                                                                    defaultChecked={true}
                                                                    checked={m.proposta_Geral}
                                                                    onChange={() => handleEscolhaPropostaGeral(m.codigo_Liga, index, m.proposta_Geral)}
                                                                    name={eval(`propostaGeral${index}`)}
                                                                    color="primary"
                                                                />
                                                            }
                                                            label={m.proposta_Geral ? "Sim" : "Não"}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid size={{xs:12, sm:3}} padding={1} >
                                            <Grid  size={{xs:12, sm:12, md:12}} display={"flex"} justifyContent={"center"} >
                                                <Typography variant="h6">Leilão</Typography>
                                            </Grid>
                                            <Grid container size={{xs:12, sm:12, md:12}} >
                                                <Grid container size={{xs:12, sm:12, md:12}} direction={"column"} display={"contents"} >
                                                    <Grid size={{xs:12, sm:6, md:6}} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                                        <Typography variant="body1">Minha Franquia</Typography>
                                                    </Grid>
                                                    <Grid size={{xs:12, sm:6, md:6}}>

                                                        <FormControlLabel
                                                            sx={{
                                                                display: 'block',
                                                            }}
                                                            control={
                                                                <Switch
                                                                    checked={m.leilao ? true : false}
                                                                    onChange={() => handleEscolhaLeilao(m.codigo_Liga, index, m.leilao)}
                                                                    name={eval(`leilao${index}`)}
                                                                    color="primary"
                                                                    defaultChecked={eval(`m.leilao${index}`)}
                                                                />
                                                            }
                                                            label={m.leilao ? "Sim" : "Não"}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{xs:12, sm:12, md:12}} display={"contents"} direction={"column"}>
                                                    <Grid size={{xs:12, sm:6, md:6}} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                                        <Typography variant="body1">Todas da Liga</Typography>
                                                    </Grid>
                                                    <Grid size={{xs:12, sm:6, md:6}} >
                                                        <FormControlLabel
                                                            sx={{
                                                                display: 'block',
                                                            }}
                                                            control={
                                                                <Switch
                                                                    defaultChecked={true}
                                                                    checked={m.leilao_Geral}
                                                                    onChange={() => handleEscolhaLeilaoGeral(m.codigo_Liga, index, m.leilao_Geral)}
                                                                    name={eval(`leilaoGeral${index}`)}
                                                                    color="primary"
                                                                />
                                                            }
                                                            label={m.leilao_Geral ? "Sim" : "Não"}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid size={{xs:12, sm:3}} padding={1} >
                                            <Grid  size={{xs:12, sm:12, md:12}} display={"flex"} justifyContent={"center"} >
                                                <Typography variant="h6">Free Agency</Typography>
                                            </Grid>
                                            <Grid container size={{xs:12, sm:12, md:12}} >
                                                <Grid container size={{xs:12, sm:12, md:12}} direction={"column"} display={"contents"} >
                                                    <Grid size={{xs:12, sm:6, md:6}} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                                        <Typography variant="body1">Minha Franquia</Typography>
                                                    </Grid>
                                                    <Grid size={{xs:12, sm:6, md:6}}>
                                                        <FormControlLabel
                                                            sx={{
                                                                display: 'block',
                                                            }}
                                                            control={
                                                                <Switch
                                                                    checked={m.freeAgency ? true : false}
                                                                    onChange={() => handleEscolhaFreeAgency(m.codigo_Liga, index, m.freeAgency)}
                                                                    name={eval(`freeAgency${index}`)}
                                                                    color="primary"
                                                                    defaultChecked={eval(`m.freeAgency${index}`)}
                                                                />
                                                            }
                                                            label={m.freeAgency ? "Sim" : "Não"}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid container size={{xs:12, sm:12, md:12}} display={"contents"} direction={"column"}>
                                                    <Grid size={{xs:12, sm:6, md:6}} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                                        <Typography variant="body1">Todas da Liga</Typography>
                                                    </Grid>
                                                    <Grid size={{xs:12, sm:6, md:6}} >
                                                        <FormControlLabel
                                                            sx={{
                                                                display: 'block',
                                                            }}
                                                            control={
                                                                <Switch
                                                                    defaultChecked={true}
                                                                    checked={m.freeAgency_Geral}
                                                                    onChange={() => handleEscolhaFreeAgencyGeral(m.codigo_Liga, index, m.freeAgency_Geral)}
                                                                    name={eval(`freeAgencyGeral${index}`)}
                                                                    color="primary"
                                                                />
                                                            }
                                                            label={m.freeAgency_Geral ? "Sim" : "Não"}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid size={{xs:12, sm:3}} padding={1} >
                                            <Grid  size={{xs:12, sm:12, md:12}} display={"flex"} justifyContent={"center"} >
                                                <Typography variant="h6">Draft</Typography>
                                            </Grid>
                                            <Grid container size={{xs:12, sm:12, md:12}} >
                                                <Grid container size={{xs:12, sm:12, md:12}} direction={"column"} display={"contents"} >
                                                    <Grid size={{xs:12, sm:6, md:6}} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                                        <Typography variant="body1">Minha Franquia</Typography>
                                                    </Grid>
                                                    <Grid size={{xs:12, sm:6, md:6}}>

                                                        <FormControlLabel
                                                            sx={{
                                                                display: 'block',
                                                            }}
                                                            control={
                                                                <Switch
                                                                    checked={m.draft ? true : false}
                                                                    onChange={() => handleEscolhaDraft(m.codigo_Liga, index, m.draft)}
                                                                    name={eval(`draft${index}`)}
                                                                    color="primary"
                                                                    defaultChecked={eval(`m.draft${index}`)}
                                                                />
                                                            }
                                                            label={m.draft ? "Sim" : "Não"}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{xs:12, sm:12, md:12}} display={"contents"} direction={"column"}>
                                                    <Grid size={{xs:12, sm:6, md:6}} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                                        <Typography variant="body1">Todas da Liga</Typography>
                                                    </Grid>
                                                    <Grid size={{xs:12, sm:6, md:6}} >
                                                        <FormControlLabel
                                                            sx={{
                                                                display: 'block',
                                                            }}
                                                            control={
                                                                <Switch
                                                                    defaultChecked={true}
                                                                    checked={m.draft_Geral}
                                                                    onChange={() => handleEscolhaDraftGeral(m.codigo_Liga, index, m.draft_Geral)}
                                                                    name={eval(`draftGeral${index}`)}
                                                                    color="primary"
                                                                />
                                                            }
                                                            label={m.draft_Geral ? "Sim" : "Não"}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid size={{xs:12, sm:3}} padding={1} >
                                            <Grid  size={{xs:12, sm:12, md:12}} display={"flex"} justifyContent={"center"} >
                                                <Typography variant="h6">Partida</Typography>
                                            </Grid>
                                            <Grid container size={{xs:12, sm:12, md:12}} >
                                                <Grid container size={{xs:12, sm:12, md:12}} direction={"column"} display={"contents"} >
                                                    <Grid size={{xs:12, sm:6, md:6}} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                                        <Typography variant="body1">Minha Franquia</Typography>
                                                    </Grid>
                                                    <Grid size={{xs:12, sm:6, md:6}}>
                                                        <FormControlLabel
                                                            sx={{
                                                                display: 'block',
                                                            }}
                                                            control={
                                                                <Switch
                                                                    checked={m.partida ? true : false}
                                                                    onChange={() => handleEscolhaPartida(m.codigo_Liga, index, m.partida)}
                                                                    name={eval(`partida${index}`)}
                                                                    color="primary"
                                                                    defaultChecked={eval(`m.partida${index}`)}
                                                                />
                                                            }
                                                            label={m.partida ? "Sim" : "Não"}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{xs:12, sm:12, md:12}} display={"contents"} direction={"column"}>
                                                    <Grid size={{xs:12, sm:6, md:6}} display={"flex"} justifyContent={"center"} alignSelf={"center"}>
                                                        <Typography variant="body1">Todas da Liga</Typography>
                                                    </Grid>
                                                    <Grid size={{xs:12, sm:6, md:6}} >
                                                        <FormControlLabel
                                                            sx={{
                                                                display: 'block',
                                                            }}
                                                            control={
                                                                <Switch
                                                                    defaultChecked={true}
                                                                    checked={m.partida_Geral}
                                                                    onChange={() => handleEscolhaPartidaGeral(m.codigo_Liga, index, m.partida_Geral)}
                                                                    name={eval(`partidaGeral${index}`)}
                                                                    color="primary"
                                                                />
                                                            }
                                                            label={m.partida_Geral ? "Sim" : "Não"}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )}
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    );
};